
<template>
    <label>
        Event date

        <div class="column">
            <input v-model.number="selected.date" type="number" min="1" max="31" v-on:input="changed"/>
        </div>

        <div class="column">
            <select v-model.number="selected.month" class="select" v-on:change="changed">
                <option v-for="( month, i ) in months" :value="i">{{ month }}</option>
            </select>
        </div>

        <div class="column">
            <input v-model.number="selected.year" type="number" :min="current.year -20" :max="current.year" v-on:input="changed"/>
        </div>
    </label>
</template>

    <script>
	export default
	{
		data()
		{
			const current = new Date(),
                selected = this.value ? new Date( this.value ) : current;

			return {
				current: {
					date: current.getDate(),
					month: current.getMonth(),
					year: current.getFullYear(),
				},
				months: [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December',
				],
				selected: {
					date: selected.getDate(),
					month: selected.getMonth(),
					year: selected.getFullYear(),
				},
			};
		},
		methods:
        {
			changed()
            {
            	const month = ( `0${ this.selected.month +1 }` ).slice( -2 ),
		            date = ( `0${ this.selected.date }` ).slice( -2 ),
                    value = `${ this.selected.year }-${ month }-${ date }`;

				this.$emit( 'input', value );
			}
		},
        props: ['value'],
	};
</script>
